<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" class="tender-list-cell_version-btn" v-on="on">
        <span> {{ teamName }} {{ $t('v.') }}{{ versionName }} </span>
        <TenderOfferVersionOldBadge v-if="version ? version.status === 'old' : false" />
        <ArrowIcon class="btn-arrow" />
      </div>
    </template>
    <div class="dropdown-body flex-column-reverse">
      <DropdownMenuElement
        v-for="(version, versionIndex) in offer.versions"
        :key="version.id"
        @click="$emit('changeSelectedVersion', offer.id, versionIndex, version.id)"
      >
        <TenderOfferVersionDropdownInfo :version="version" />
      </DropdownMenuElement>
    </div>
  </v-menu>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import ArrowIcon from '@/assets/icons/chevron-down.svg';
  import { HEADER_ROW_END, HEADER_ROW_START } from '@/containers/tender/tender-list/constants';
  import TenderOfferVersionOldBadge from '@/components/tenders/tender-offer-version-badges/TenderOfferVersionOldBadge';
  import TenderOfferVersionDropdownInfo from '@/components/tenders/TenderOfferVersionDropdownInfo';

  export default {
    name: 'TenderListOfferVersionSelector',
    components: {
      TenderOfferVersionDropdownInfo,
      TenderOfferVersionOldBadge,
      VMenu,
      ArrowIcon,
      DropdownMenuElement,
    },
    props: {
      offer: {
        type: Object,
        required: true,
      },
      selectedVersion: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        HEADER_ROW_START,
        HEADER_ROW_END,
      };
    },
    computed: {
      teamName() {
        return this.offer?.contractor_team?.name || '';
      },
      version() {
        // selectedVersions заполняется при создании компонента, при смене версий он обновляется
        // данными формата {"9": {versionIndex: 0, versionId: 12},"10":{versionIndex: 0, versionId: 12}},
        // где ключ - это айди оффера, а значение - это мапа с айди выбранной версии и ее индексом
        let selectedVersionIndex = this.selectedVersion?.versionIndex;

        // Если версии нет в данной мапе, то выбираем последнюю по умочланию
        selectedVersionIndex =
          selectedVersionIndex !== undefined
            ? selectedVersionIndex
            : this.offer.versions?.length - 1;

        return this.offer.versions?.[selectedVersionIndex];
      },
      versionName() {
        return this.version?.name || this.$t('Version title');
      },
    },
  };
</script>

<style scoped>
  .dropdown-body {
    width: 332px;
  }
</style>
